import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '../utils/auth'
import Home from '../views/Home.vue'
import Products from '../views/Products.vue'
import ProductDetail from '../views/ProductDetail.vue'
import Docs from '../views/Docs.vue'
import Playground from '../views/Playground.vue'
import Console from '../views/Console.vue'
import Keys from '../views/Keys.vue'
import Usage from '../views/Usage.vue'
import Recharge from '../views/Recharge.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'Home', component: Home, meta: { title: '首页' } },
    { path: '/login', name: 'Login', component: Login, meta: { title: '登录', guest: true } },
    { path: '/type/:typeId', name: 'Products', component: Products, meta: { title: '所有产品' } },
    { path: '/product/:id', name: 'ProductDetail', component: ProductDetail, meta: { title: '产品详情' } },
    { path: '/docs', name: 'Docs', component: Docs, meta: { title: 'API 文档' } },
    {
      path: '/playground',
      name: 'Playground',
      component: Playground,
      meta: { title: '在线调试', requiresAuth: true }
    },
    {
      path: '/console',
      name: 'Console',
      component: Console,
      meta: { title: '控制台', requiresAuth: true }
    },
    {
      path: '/keys',
      name: 'Keys',
      component: Keys,
      meta: { title: 'API Keys', requiresAuth: true }
    },
    {
      path: '/usage',
      name: 'Usage',
      component: Usage,
      meta: { title: '消耗明细', requiresAuth: true }
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge,
      meta: { title: '积分充值', requiresAuth: true }
    },
    { path: '/api', redirect: '/type/all' }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.requiresAuth && !isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }
  if (to.meta && to.meta.guest && isLoggedIn() && to.path === '/login') {
    next((to.query.redirect && String(to.query.redirect)) || '/playground')
    return
  }
  next()
})

router.afterEach(to => {
  const t = (to.meta && to.meta.title) || 'Idoing'
  document.title = `${t} · Idoing API`
})

export default router
